import { Input, Select } from 'antd';
import { memo, useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { css } from '@emotion/css';
import { useKeyword } from './state';

/**
 * SPU_NAME = 1; SPU_ID = 2; SELLER_SPU = 3; SELLER_SKU = 4;
 */
type KeywordType = 1 | 2 | 3 | 4;

function KeyWordSelect() {
  const { t } = useTranslate();
  const { keywordType, setKeywordBoth, keyword, setKeyword } = useKeyword();
  const [actKeywordType, setActKeywordType] = useState<KeywordType>(keywordType);

  useEffect(() => {
    if (!!keyword) {
      setKeywordBoth(actKeywordType, keyword);
    }
  }, [actKeywordType, keyword, setKeywordBoth]);

  const keywordTypeLabelMap: Record<KeywordType, string> = {
    1: t('sider.商品名称'),
    2: t('sider.商品ID'),
    3: t('aide.主商品货号'),
    4: t('sider.SKU货号'),
  };
  return (
    <Input.Group
      compact
      className={css`
        flex: 1 0 259px;
        display: flex !important;
      `}
    >
      <Select
        className="max-w-[112px]"
        dropdownMatchSelectWidth={false}
        value={actKeywordType}
        onChange={(value) => setActKeywordType(value)}
        options={Object.entries(keywordTypeLabelMap).map(([value, label]) => {
          return {
            value: parseInt(value, 10),
            label,
          };
        })}
      />
      <Input.Search
        allowClear
        title={t('trade.请输入')}
        placeholder={t('trade.请输入')}
        onPressEnter={(e: any) => {
          setKeyword(e?.target?.value);
        }}
        onSearch={(value) => {
          setKeyword(value);
        }}
      />
    </Input.Group>
  );
}

export default memo(KeyWordSelect);
